import styled from 'styled-components';

export const ListableCardContainer = styled.div<{ marginBottom?: string; roundBorders?: boolean; padding?: string }>`
	display: flex;
	padding: ${({ padding }) => padding || '20px'};
	position: relative;
	border: 1px solid #e5e5e5;
	background-color: #fff;
	border-radius: 5px;
	margin-bottom: ${({ marginBottom }) => marginBottom || 0};
	box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
	overflow: hidden;
	cursor: pointer;
	:hover {
		border: 1px solid #000;
	}
`;
